import { Box, Drawer, SxProps, Theme, useTheme } from '@mui/material';

import { DRAWER_WIDTH } from '../../../config';
import { useUiStore } from '../../../store/ui';
import AppNavbar from '../app-navbar/AppNavbar';

const getStyles = (theme: Theme): { [key: string]: SxProps } => {
  return {
    wrapper: {
      display: "flex",
      flexDirection: "column",
      zIndex: 4,
      background: theme.palette.background.default,
      [theme.breakpoints.up("md")]: {
        width: DRAWER_WIDTH,
        minWidth: DRAWER_WIDTH,
      },
    },
    navbar: {
      display: "flex",
      overflow: "hidden",
      flexDirection: "column",
      flex: "1 1 auto",
      width: DRAWER_WIDTH,
      minWidth: DRAWER_WIDTH,
      height: "100%",
      zIndex: 4,
      transition: theme.transitions.create(["width", "min-width"], {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.shorter,
      }),
      boxShadow: theme.shadows[3],
    },
    left: {
      left: 0,
    },
    navbarContent: {
      flex: "1 1 auto",
    },
  };
};

export default function AppSidebar() {
  const { drawerState, toggleDrawerState } = useUiStore();

  const theme = useTheme();
  const styles = getStyles(theme);

  return (
    <Box sx={styles.wrapper}>
      <Box sx={{ ...styles.navbar, display: { xs: "none", md: "block" } }}>
        <AppNavbar />
      </Box>

      <Drawer
        anchor="left"
        variant="temporary"
        open={drawerState}
        onClose={toggleDrawerState}
        PaperProps={{ sx: { ...styles.navbar } }}
        ModalProps={{
          keepMounted: true, // Better open performance on mobile.
        }}
        sx={{ display: { xs: "block", md: "none" } }}
      >
        <AppNavbar />
      </Drawer>
    </Box>
  );
}
